import { ChangeDetectionStrategy, Component } from '@angular/core';
import { SettingsModule } from '../../settings.module';

@Component({
  selector: 'security',
  standalone: true,
  imports: [SettingsModule],
  templateUrl: './security.component.html',
  styleUrls: ['./security.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SecurityComponent {}
